export const COUNTRIES = {
  GET_COUNTRIES: 'GET_COUNTRIES',
  GET_CITIES: 'GET_CITIES',
  GET_COUNTRIES_SUCCESS: 'GET_COUNTRIES_SUCCESS',
  GET_CITIES_SUCCESS: 'GET_CITIES_SUCCESS',
  GET_CITIES_FAIL: 'GET_CITIES_FAIL',
  GET_COUNTRIES_FAIL: 'GET_COUNTRIES_FAIL',

  ADD_COUNTRY: 'ADD_COUNTRY',
  ADD_CITY: 'ADD_CITY'
};
